import {useToast as useNbToast} from 'native-base';

import {message as t} from '../../utils/messages';

const toastServerErrorId = 'toast-server-error';

const toastInputsErrorId = 'toast-inputs-error';

const toastRecoverErrorId = 'toast-recover-error';

const toastWhatsAppErrorId = 'toast-whatsapp-error';

const toastCopiedErrorId = 'toast-copied-error';

const toastSignUpErrorId = 'toast-signup-error';

const toastNotificationId = 'toast-notification-message';

const toastRemoteErrorId = 'toast-remote-error';

const toastSendProofErrorId = 'toast-send-proof-error';

const useToast = () => {
  const toast = useNbToast();

  const showLoginError = () => {
    if (!toast.isActive(toastServerErrorId)) {
      toast.show({
        id: toastServerErrorId,
        bgColor: 'red.400',
        _description: {
          padding: 3,
        },
        description: t('message-login-error'),
      });
    }
  };

  const showReadFileError = () => {
    if (!toast.isActive(toastServerErrorId)) {
      toast.show({
        id: toastServerErrorId,
        bgColor: 'red.400',
        _description: {
          padding: 3,
        },
        description: t('message-file-read-error'),
      });
    }
  };

  const showServerError = () => {
    if (!toast.isActive(toastServerErrorId)) {
      toast.show({
        id: toastServerErrorId,
        bgColor: 'red.400',
        _description: {
          padding: 3,
        },
        description: t('message-server-error'),
      });
    }
  };

  const showMessageError = (msg: string) => {
    if (!toast.isActive(toastServerErrorId)) {
      toast.show({
        id: toastServerErrorId,
        bgColor: 'red.400',
        _description: {
          padding: 3,
        },
        description: msg,
      });
    }
  };

  const showInputsError = () => {
    if (!toast.isActive(toastInputsErrorId)) {
      toast.show({
        id: toastInputsErrorId,
        bgColor: 'red.400',
        _description: {
          padding: 3,
        },
        description: t('message-inputs-error'),
      });
    }
  };

  const showProofError = () => {
    if (!toast.isActive(toastSendProofErrorId)) {
      toast.show({
        id: toastSendProofErrorId,
        bgColor: 'red.400',
        _description: {
          padding: 3,
        },
        description: t('message-proof-error'),
      });
    }
  };

  const showC2PError = () => {
    if (!toast.isActive(toastServerErrorId)) {
      toast.show({
        id: toastServerErrorId,
        bgColor: 'red.400',
        _description: {
          padding: 3,
        },
        description: t('message-c2p-error'),
      });
    }
  };

  const showOrderError = () => {
    if (!toast.isActive(toastServerErrorId)) {
      toast.show({
        id: toastServerErrorId,
        bgColor: 'red.400',
        _description: {
          padding: 3,
        },
        description: t('message-order-error'),
      });
    }
  };

  const showInvoiceError = () => {
    if (!toast.isActive(toastServerErrorId)) {
      toast.show({
        id: toastServerErrorId,
        bgColor: 'red.400',
        _description: {
          padding: 3,
        },
        description: t('message-invoice-error'),
      });
    }
  };

  const showRecoverError = () => {
    if (!toast.isActive(toastRecoverErrorId)) {
      toast.show({
        id: toastServerErrorId,
        bgColor: 'red.400',
        _description: {
          padding: 3,
        },
        description: t('message-recover-error'),
      });
    }
  };

  const showSignUpError = () => {
    if (!toast.isActive(toastSignUpErrorId)) {
      toast.show({
        id: toastSignUpErrorId,
        bgColor: 'red.400',
        _description: {
          padding: 3,
        },
        description: t('message-signup-error'),
      });
    }
  };

  const showCopiedSignal = () => {
    if (!toast.isActive(toastCopiedErrorId)) {
      toast.show({
        id: toastCopiedErrorId,
        bgColor: 'blue.400',
        _description: {
          padding: 3,
        },
        description: t('message-copied-signal'),
      });
    }
  };

  const showWhatsAppError = (msg?: string) => {
    if (!toast.isActive(toastWhatsAppErrorId)) {
      toast.show({
        id: toastWhatsAppErrorId,
        bgColor: 'red.400',
        _description: {
          padding: 3,
        },
        description: msg ?? t('default-message-whatsapp-error'),
      });
    }
  };

  const showCustomerRegistrationError = (msg?: string) => {
    if (!toast.isActive(toastWhatsAppErrorId)) {
      toast.show({
        id: toastWhatsAppErrorId,
        bgColor: 'red.400',
        _description: {
          padding: 3,
        },
        description: msg ?? t('message-customer-registration-error'),
      });
    }
  };

  const showNotification = (title: string, msg: string) => {
    if (!toast.isActive(toastNotificationId)) {
      toast.show({
        id: toastNotificationId,
        bgColor: 'red.400',
        _description: {
          padding: 3,
        },
        title,
        description: msg,
      });
    }
  };

  const showSyncError = (msg?: string) => {
    if (!toast.isActive(toastWhatsAppErrorId)) {
      toast.show({
        id: toastWhatsAppErrorId,
        bgColor: 'red.400',
        _description: {
          padding: 3,
        },
        description: msg ?? t('message-sync-error'),
      });
    }
  };

  const showRemoteMessageError = (msg?: string) => {
    if (!toast.isActive(toastRemoteErrorId)) {
      toast.show({
        id: toastRemoteErrorId,
        bgColor: 'red.400',
        _description: {
          padding: 3,
        },
        description: msg ?? t('message-sync-error'),
      });
    }
  };

  return {
    showServerError,
    showInputsError,
    showLoginError,
    showProofError,
    showReadFileError,
    showRecoverError,
    showSignUpError,
    showMessageError,
    showCopiedSignal,
    showWhatsAppError,
    showNotification,
    showOrderError,
    showInvoiceError,
    showCustomerRegistrationError,
    showSyncError,
    showC2PError,
    showRemoteMessageError,
  };
};

export default useToast;
